import { Reducer } from 'redux';
import { getType } from '@anm/helpers/saga/typesafe-actions';

import { fetchHostingStatsAsync } from '../actions';
import { UserActions } from '../types';

import { initialUserState } from '.';

const hostingStatsReducer: Reducer<typeof initialUserState, UserActions> = (
  state = initialUserState,
  action
) => {
  switch (action.type) {
    case getType(fetchHostingStatsAsync.request): {
      return {
        ...state,
        hostingStats: {
          isError: false,
          isPending: true
        }
      };
    }
    case getType(fetchHostingStatsAsync.success): {
      return {
        ...state,
        hostingStats: {
          data: action.payload,
          isError: false,
          isPending: false
        }
      };
    }
    case getType(fetchHostingStatsAsync.failure): {
      const error = action.payload;

      return {
        ...state,
        hostingStats: {
          error,
          isError: true,
          isPending: false
        }
      };
    }
    default:
      return state;
  }
};

export default hostingStatsReducer;
